import React, { useEffect, useState } from 'react';
import PageLayout from '../../../../../layout/dashboard/tableLayout';
import {
	RavenBadge,
	RavenButton,
	RavenInputField,
	RavenModal,
	RavenNumberFormat,
	RavenTable,
	RavenTableRow,
	RavenToggleSlide,
	RavenToolTip,
	toast,
} from '@ravenpay/raven-bank-ui';

import { faker } from '@faker-js/faker';
import '../style/index.css';
import { generateRandomColor } from '../../../../../utils/helper/color';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../../../redux/store';
import Skeleton from 'react-loading-skeleton';
import { logger } from '../../../../../services/logger';
import { OmniSearch } from '../../..redux/transaction';
import Copy from '../../../../../components/common/copyCheck';
import TransactionModal from '../../../../../components/common/transactionModal';
import '../style/index.css';
import { debounce } from 'lodash';
import { FaRegEye } from 'react-icons/fa';
import BadgeComponent from '../../../../../components/common/badge/BadgeComponent';
import RootState, {
	AssignBankBoxPayload,
	BankBoxUser,
} from '../../../../../../redux/types';
import RequestLayout from '../RequestLayout';
import {
	capitalizeAllLetter,
	formatDateTime,
	formatNumWithComma,
	formatTypeFunction,
	getActionNamesByPolicyName,
	reactSelectStyle,
	searchParams,
	symbol,
	validateStringForTerminalId,
} from '../../../../../../utils/helper/Helper';
import { icons } from '../../../../../../assets/icons';
import { bankboxAPI } from '../../../../../../redux/bankbox';
import useDebounce from '../../../../../../hooks/UseDebounce';
import { omniSearch } from '../../../../../../redux/transaction';
import { getTransfers } from '../../../../../../redux/wallet';
import DashboardLayout from '../../../../../../layout/dashboard/dashboardLayout';
import EmptyScreen from '../../../../../../components/common/emptyScreen';
import SmartFilter from '../../../../../../components/common/smartFilter';
import Pagination from '../../../../../../components/common/pagination';
import TwoDetailView from '../../../../../../components/common/TwoDetailView';
import DateFragmentBox from '../../../../../../components/common/DateFragmentBox';
import MobileTableCard from '../../../../../../components/common/table/mobile/MobileTable';
import DeviceRequest from '../DeviceRequest';
import RequestModal from '../RequestModal';
import ChangeRequestStatusModal from '../ChangeRequestStatusModal';
import ExportModal from '../../../../../../components/common/exportModal';
import CameraAssignBox from '../../../users/cameraAssign/CameraAssignBox';
import { useDarkMode } from '../../../../../../hooks/useDarkMode';

const BankboxRequest = () => {
	const [showTable, setShowTable] = useState(false);
	const { profile } = useSelector((state: RootState) => state.settings);
	const [demo, setDemo] = useState(true);
	const [showExport, setShowExport] = useState<boolean>(false);
	const [activeCurrency, setActiveCurrency] = useState('ngn');
	const [currentPage, setCurrentPage] = useState(1);
	const [activeFilter, setActiveFilter] = useState<string>('');
	const [showConfiguration, setShowConfiguration] = useState<boolean>(false);
	type showModalProp = {
		status: boolean;
		export: boolean;
	};
	const [showModal, setShowModal] = useState<showModalProp>({
		status: false,
		export: false,
	});
	const [view, onView] = useState<any>({
		show: false,
		view: '',
	});
	const [searchQuery, setSearchQuery] = useState('');

	const [searchValue, setSearchValue] = useState('');

	const clearSearch = () => {
		setSearchValue(''); // Clear the search value
	};

	useState<string>('business-account');
	const [boot, onBoot] = useState(false);
	const [dateFilter, setDateFilter] = useState<{
		to: Date | any;
		from: Date | any;
	}>({
		from: '',
		to: '',
	});

	const [showDrop, setShowDrop] = useState<{
		show: boolean;
		id: number | string;
	}>({
		show: false,
		id: '',
	});
	const { searchLoading } = useSelector(
		(state: RootState) => state.transaction
	);
	const { loading, all_bankbox_request } = useSelector(
		(state: RootState) => state.bankbox
	);

	const [refreshTable, setRefreshTable] = useState(false);
	const req = all_bankbox_request?.data;
	const debounceSearchTerm = useDebounce(searchQuery, 1000);

	useEffect(() => {
		getAllUserFirst();
	}, [currentPage, refreshTable]);
	useEffect(() => {
		let isMount = true;
		// logger.log('searching');

		if (isMount && debounceSearchTerm?.length > 2) {
			dispatch(omniSearch(searchQuery));
		}

		// if (isMount && debounceSearchTerm?.length < 1) {
		// 	dispatch(
		// 		getTransfers({
		// 			page: currentPage,
		// 			limit: 20,
		// 		})
		// 	);
		// }

		return () => {
			isMount = false;
		};
	}, [debounceSearchTerm]);
	useEffect(() => {
		if (
			typeof dateFilter.from === 'object' ||
			typeof dateFilter.to === 'object'
		) {
			setDateFilter({
				to: '',
				from: '',
			});
		}
	}, [activeFilter]);

	useEffect(() => {
		if (activeFilter !== undefined) {
			setActiveFilter('');
		}
	}, [dateFilter.to, dateFilter.from]);

	useEffect(() => {
		setShowTable(!(loading || searchLoading || req?.length < 1));
	}, [loading, searchLoading, req]);

	const navigate = useNavigate();
	const dispatch = useDispatch();

	const { transfers } = useSelector((state: RootState) => state.wallet);

	function formatStatus(status: string | number) {
		let s;
		// 		0 = pending, 1 = approved, 2 = dispatched, 3 = delivered
		// [3:17 PM] 4 = declined
		if (status === 0 || status === 'pending') {
			s = 'pending';
		}
		if (status === 1) {
			s = 'approved';
		}
		if (status === 2) {
			s = 'dispatched';
		}
		if (status === 3) {
			s = 'delivered';
		}
		if (status === 4) {
			s = 'declined';
		}
		return s;
	}
	function formatStatusColor(status: string | number) {
		let s;
		// 		0 = pending, 1 = approved, 2 = dispatched, 3 = delivered
		// [3:17 PM] 4 = declined
		if (status === 0 || status === 'pending') {
			s = 'yellow';
		}
		if (status === 1) {
			s = 'green';
		}
		if (status === 2) {
			s = 'purple';
		}
		if (status === 3) {
			s = 'info';
		}
		if (status === 4) {
			s = 'red';
		}
		return s;
	}

	const [noDataFound, setNoDataFound] = useState<boolean>(true);

	const getAllUserFirst = async () => {
		const data = await dispatch(
			bankboxAPI.getAllBankBoxRequest({
				page: currentPage,
				per_page: 20,
			})
		);
		if (data?.payload?.status === 'success') {
			// //(data);

			const checkLength = data?.payload?.data?.data?.data;
			if (checkLength?.length > 0) {
				setNoDataFound(false);
				// //('ooo');
			} else {
				setNoDataFound(true);
			}
		}
	};

	const handleFinish = () => {
		setRefreshTable(!refreshTable);
		setShowModal((prev) => {
			return { ...prev, export: false, status: false };
		});
	};

	function isDropped(idx: number | string) {
		if (showDrop.id === idx && showDrop.show) return true;
		else return false;
	}

	const [createModal, setCreateModal] = useState<boolean>(false);
	const [selectedType, setSelectedType] = useState('Yes, It is');
	const [assignFormData, setAssignFormData] = useState<AssignBankBoxPayload>({
		// affiliate_app_id: '',
		poseidon_business_email: '',
		serial_number: '',
		label: '',
		poseidon_business_name: '',
		exist_nibbs: true,
		// term_id: '',
		// auto_gen: true,
		auto_generate: true,
		is_nibss: true,
		terminal_id: '',
		device_type: '',
	});
	const selectTypeList = ['Yes, It is', 'No, it’s not'];
	const [showTerminalError, setShowTerminalError] = useState(false);
	const [autoAssign, setAutoAssign] = useState(true);
	const formatState = (param: any) => {
		if (param?.length > 0) {
			const newList = param?.map((chi: any) => {
				return { label: chi, value: chi };
			});
			return newList;
		}
	};
	const { all_states, all_lga } = useSelector(
		(state: RootState) => state.bankbox
	);

	interface formComponent {
		state: any;
		lga: any;
	}

	const [details, setDetails] = useState<formComponent>({
		state: '',
		lga: '',
	});

	const [singleChild, setSingleChild] = useState<any>({});
	const [theme, toggleTheme] = useDarkMode(localStorage.getItem('theme'));
	const [uploadViaCamera, setUploadViaCamera] = useState(false);
	const [terminalDetails, setTerminalDetails] = useState<any>({});
	const [assignBankbox, setAssignBankbox] = useState<{
		on: boolean;
		chi: BankBoxUser;
	}>({
		on: false,
		chi: {
			id: 0,
			fname: '',
			lname: '',
			poseidon_email: '',
			bvn: '',
			nin: '',
			phone: '',
			affiliate_app: '',
			affiliate_app_id: '',
			poseidon_business_name: '',
			poseidon_business_address: '',
			poseidon_business_type: null,
			poseidon_business_description: '',
			poseidon_profile_reference: '',
			business_category: '',
			region: '',
			created_at: '',
			updated_at: '',
			lga: '',
		},
	});

	async function handleAssign() {
		if (
			!validateStringForTerminalId(assignFormData?.terminal_id) &&
			!autoAssign
		) {
			toast.error(
				'Terminal ID must be exactly 8 characters, all capitalized and alphanumeric.'
			);
			setShowTerminalError(true);
			return;
		}

		const obj = {
			...assignFormData,
			auto_generate: autoAssign,
			is_nibss: autoAssign ? false : assignFormData?.exist_nibbs,
			terminal_id: assignFormData?.terminal_id,
			state: details?.state?.value,
			city: details?.lga,
			// poseidon_business_name: user_merchant?.user?.poseidon_business_name,
			// poseidon_business_email: user_merchant?.user?.poseidon_email,
		};
		// //(obj);

		const resp = await dispatch(bankboxAPI.assignBankbox(obj));

		if (resp.payload?.status === 'success') {
			setAssignBankbox({
				...assignBankbox,
				on: false,
			});
			const email = searchParams.get('user_email');
			dispatch(bankboxAPI.getSingleUser({ email: email as string }));
			setDetails({ lga: '', state: '' });
			setAssignFormData({
				exist_nibbs: true,
				// affiliate_app_id: '',
				poseidon_business_email: '',
				serial_number: '',
				label: '',
				poseidon_business_name: '',
				auto_generate: false,
				is_nibss: true,
				terminal_id: '',
				device_type: '',
			});
		}
	}

	const infoIcon = (
		<svg
			className="img"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_164_20412)">
				<path
					d="M7.99967 10.6668V8.00016M7.99967 5.3335H8.00634M14.6663 8.00016C14.6663 11.6821 11.6816 14.6668 7.99967 14.6668C4.31778 14.6668 1.33301 11.6821 1.33301 8.00016C1.33301 4.31826 4.31778 1.3335 7.99967 1.3335C11.6816 1.3335 14.6663 4.31826 14.6663 8.00016Z"
					stroke="black"
					strokeWidth="1.2"
					strokeLinecap="round"
					strokeLinejoin="round"
				/>
			</g>
			<defs>
				<clipPath id="clip0_164_20412">
					<rect width="16" height="16" fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
	const cameraUploadIcon = (
		<svg
			className="img"
			width="20"
			height="20"
			viewBox="0 0 20 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				className="dull-bright-filter"
				d="M6 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V6M6 19H5.8C4.11984 19 3.27976 19 2.63803 18.673C2.07354 18.3854 1.6146 17.9265 1.32698 17.362C1 16.7202 1 15.8802 1 14.2V14M19 6V5.8C19 4.11984 19 3.27976 18.673 2.63803C18.3854 2.07354 17.9265 1.6146 17.362 1.32698C16.7202 1 15.8802 1 14.2 1H14M19 14V14.2C19 15.8802 19 16.7202 18.673 17.362C18.3854 17.9265 17.9265 18.3854 17.362 18.673C16.7202 19 15.8802 19 14.2 19H14M1 10H1.01M5.5 10H5.51M14.5 10H14.51M10 10H10.01M19 10H19.01"
				stroke="black"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);

	function DropMore({ className, idx, chi }: any) {
		return (
			<div className={`more-wrap ${className}`}>
				{getActionNamesByPolicyName(
					profile?.rolePolicies?.policies,
					'bankbox requests'
				)?.includes('approve_bankbox_request') ||
				getActionNamesByPolicyName(
					profile?.rolePolicies?.policies,
					'bankbox requests'
				)?.includes('deny_bankbox_request') ? (
					<div
						style={{
							opacity: '1',
							cursor: 'pointer',
						}}
						onClick={() => {
							setSingleChild(chi);
							setShowModal((prev) => {
								return { ...prev, status: true };
							});
						}}
						className="more_item"
					>
						<figure>
							{
								<svg
									className="img"
									width="24"
									height="24"
									viewBox="0 0 24 24"
									fill="none"
									xmlns="http://www.w3.org/2000/svg"
								>
									<circle cx="12" cy="12" r="12" fill="#F9F9F9" />
									<path
										d="M13.5253 10.5H8.75C8.05964 10.5 7.5 9.94036 7.5 9.25C7.5 8.55964 8.05964 8 8.75 8H13.5253M10.4747 16H15.25C15.9404 16 16.5 15.4404 16.5 14.75C16.5 14.0596 15.9404 13.5 15.25 13.5H10.4747M7.5 14.75C7.5 15.7165 8.2835 16.5 9.25 16.5C10.2165 16.5 11 15.7165 11 14.75C11 13.7835 10.2165 13 9.25 13C8.2835 13 7.5 13.7835 7.5 14.75ZM16.5 9.25C16.5 10.2165 15.7165 11 14.75 11C13.7835 11 13 10.2165 13 9.25C13 8.2835 13.7835 7.5 14.75 7.5C15.7165 7.5 16.5 8.2835 16.5 9.25Z"
										stroke="var(--primary-base-color)"
										strokeLinecap="round"
										strokeLinejoin="round"
									/>
								</svg>
							}
						</figure>
						<p>{`Change Status`}</p>
					</div>
				) : (
					''
				)}
				<div
					style={{
						opacity: '1',
						cursor: 'pointer',
					}}
					onClick={() => {
						onView({
							show: true,
							content: chi,
						});
					}}
					className="more_item"
				>
					<figure>
						<FaRegEye />
					</figure>
					<p>View Request Details</p>
				</div>
				{getActionNamesByPolicyName(
					profile?.rolePolicies?.policies,
					'merchants'
				)?.includes('edit_merchant') && (
					<div
						style={{
							opacity: '1',
							cursor: 'pointer',
						}}
						onClick={() => {
							navigate('/dashboard-users?user_email=' + chi.email);
						}}
						className="more_item"
					>
						<figure>
							<FaRegEye />
						</figure>
						<p>View Merchant Details</p>
					</div>
				)}
			</div>
		);
	}
	if (
		!getActionNamesByPolicyName(
			profile?.rolePolicies?.policies,
			'bankbox requests'
		)?.includes('view_bankbox_requests')
	) {
		return (
			<DashboardLayout>
				<>
					<EmptyScreen
						loading={Object?.keys(profile)?.length < 1 ? true : false}
						title="Permission Denied"
						subTitle="You have no permission to access this page, Please contact admin or support."
					></EmptyScreen>
				</>
			</DashboardLayout>
		);
	}

	return (
		<>
			<RequestLayout>
				{!noDataFound && (
					<div
						onClick={() => {
							setShowDrop({
								show: false,
								id: '',
							});
						}}
						className="global-search-pagination-filter-box"
					>
						<SmartFilter
							searchTitle="Search by email"
							defaultFilterBy="status"
							onSearchChange={debounce((e) => {
								clearSearch();
								// //(e);
								dispatch(
									bankboxAPI.getAllBankBoxRequest({
										per_page: 20,
										page: currentPage,
										search: e,
									})
								);
							}, 500)}
							// 		0 = pending, 1 = approved, 2 = dispatched, 3 = delivered
							// [3:17 PM] 4 = declined
							filters={[
								{
									label: 'Status',
									filterBy: 'status',
									options: [
										{
											label: 'Declined',
											value: '4',
										},
										{
											label: 'Approved',
											value: '1',
										},
										{
											label: 'Dispatched',
											value: '2',
										},
										{
											label: 'Delivered',
											value: '3',
										},
										{
											label: 'Pending',
											value: '0',
										},
										{
											label: 'All',
											value: ' ',
										},
									],
								},
							]}
							hideExport
							onExport={() => setShowExport(true)}
							page="bankbox_requests"
						/>
						<Pagination
							className="top-bar__pagination"
							currentPage={currentPage}
							itemsPerPage={all_bankbox_request?.perPage}
							totalItems={all_bankbox_request?.total}
							onPageChange={function (page: number): void {
								setCurrentPage(page);
							}}
						/>
					</div>
				)}

				<div
					onClick={() => {
						setShowDrop({
							show: false,
							id: '',
						});
					}}
					className="content__main"
				>
					<div className="main__wrap">
						{!showTable && req.length < 1 ? (
							<EmptyScreen
								// goBackToTable={true}
								onBackToTableClick={() => {
									//('Back to Table Clicked!');

									setShowTable(true);
								}}
								loading={loading || searchLoading}
								loadingText={
									searchLoading ? 'Searching...' : 'Loading Requests...'
								}
								title="No Requests Found"
								subTitle="You don't have any bankbox requests yet, place a new request and have them displayed here."
							/>
						) : (
							<>
								<div className="transaction__table non-mobile">
									<RavenTable
										action={false}
										className="table__main"
										headerList={[
											'QUANTITY',
											'AMOUNT',
											'MERCHANT EMAIL',
											'MOBILE',
											'REQUEST DATE',
											'STATUS',
											'ACTION',
										]}
									>
										{req?.map((chi, idx) => {
											return (
												<React.Fragment key={idx}>
													<RavenTableRow
														onRowClick={() => {
															onView({
																show: true,
																content: chi,
															});
														}}
														className="table__main"
														six={
															loading ? (
																<Skeleton
																	style={{ borderRadius: '10px' }}
																	width={80}
																	height={20}
																/>
															) : (
																<RavenBadge
																	type={formatStatusColor(chi.status)}
																	text={formatStatus(chi.status)}
																/>
															)
														}
														two={
															loading ? (
																<Skeleton width={100} height={20} />
															) : (
																<TwoDetailView
																	title={RavenNumberFormat(chi?.amount)}
																	text_one={`at ${RavenNumberFormat(
																		chi?.device_price
																	)} for 1`}
																/>
															)
														}
														five={
															loading ? (
																<Skeleton width={100} height={20} />
															) : (
																<DateFragmentBox date={chi?.created_at} />
															)
														}
														one={
															loading ? (
																<Skeleton width={100} height={20} />
															) : (
																chi.quantity + '' + '   Pieces'
															)
														}
														seven={
															<div
																style={{ position: 'relative' }}
																onClick={(e) => {
																	e.stopPropagation();
																	setShowDrop((prev) => {
																		return {
																			...prev,
																			id: idx,
																			show:
																				showDrop?.id === idx
																					? !showDrop.show
																					: true,
																		};
																	});
																}}
															>
																<DropMore
																	idx={idx}
																	className={isDropped(idx) && 'show-drop'}
																	chi={chi}
																/>
																{icons.three_dots(
																	theme === 'light' ? '#F7F7F7' : '#ffffff1a',
																	theme === 'light' ? '#020202' : '#ffffff'
																)}
															</div>
														}
														four={
															loading ? (
																<Skeleton width={80} height={20} />
															) : (
																<div className="type-wrap">
																	<span>{(chi?.phone as string) || '---'}</span>
																</div>
															)
														}
														three={
															loading ? (
																<Skeleton width={100} height={20} />
															) : (
																chi.email
															)
														}
													/>
												</React.Fragment>
											);
										})}
									</RavenTable>
								</div>

								<div className="atlas-mobile-table-wrap">
									{req?.map((chi, idx) => {
										return (
											<MobileTableCard
												key={idx}
												title={chi.email}
												text={formatDateTime(chi.created_at)}
												amount={
													symbol('ngn') + formatNumWithComma(chi.amount, 'ngn')
												}
												img={undefined}
												svg={undefined}
												avatar={''}
												amountColor={'var(--primary-base-color)'}
												type={''}
												showImg={true}
												loading={loading}
												onRowClick={() =>
													onView({
														show: true,
														content: chi,
													})
												}
												textTwo={''}
											/>
										);
									})}
								</div>
							</>
						)}
					</div>
				</div>
			</RequestLayout>

			<RavenModal
				visble={createModal}
				onClose={() => setCreateModal(false)}
				className={'bankbox-create-modal bankbox-create-setup-modal'}
				onBtnClick={function (e?: any): void {
					throw new Error('Function not implemented.');
				}}
			>
				<DeviceRequest
					onComplete={() => {
						setCreateModal(false),
							toast.success('BankBox merchant created successfully');
					}}
				/>
			</RavenModal>

			<RequestModal
				singleObj={view?.content}
				isLoadingDetails={true}
				reference={view?.reference}
				transactionType={view?.transactionTyp}
				status={view?.content?.status}
				onClose={() =>
					onView({
						show: false,
						content: {
							type: '',
							bank: '',
							description: '',
							amount: '',
							date: '',
							session_id: '',
							account_number: '',
							email: '',
							created_at: function (created_at: any): string {
								throw new Error('Function not implemented.');
							},
							updated_at: function (updated_at: any): string {
								throw new Error('Function not implemented.');
							},
						},
						on: false,
					})
				}
				visible={view.show}
				direction={view?.content?.direction}
				title={'Request Details'}
				amountt={view?.content?.amount as unknown as number}
				onClick={() => {}}
				meta={view?.content?.source}
				content={[
					{
						label: 'Quantity',
						value: `${view?.content?.quantity || ''}   Pieces` || '---',
					},
					{
						label: 'Amount',
						value:
							symbol('ngn') +
								formatNumWithComma(view?.content?.amount, 'ngn') || '---',
					},
					{
						label: 'Email',
						value: view?.content?.email || '---',
					},
					{
						label: 'Business Name',
						value:
							capitalizeAllLetter(view?.content?.merchant_business_name) ||
							'---',
					},
					{
						label: 'Mobile',
						value: view?.content?.phone || '---',
					},
					{
						label: 'Delivery State',
						value: view?.content?.delivery_state || '---',
					},
					{
						label: 'Delivery Address',
						value: view?.content?.delivery_address || '--',
					},
					{
						label: 'Delivery Option ',
						value: formatTypeFunction(view?.content?.delivery_option) || '---',
						// copy: true,
					},
					{
						label: 'Status',
						value: (
							<RavenBadge
								type={formatStatusColor(view?.content?.status)}
								text={formatStatus(view?.content?.status)}
							/>
						),
						// copy: true,
					},
					{
						label: 'Request Date',
						value: formatDateTime(
							view?.content?.created_at as unknown as string
						),
						// value: <DateFragmentBox date={view?.content?.created_at} />,
					},
					// {
					// 	label: 'Updated At',
					// 	value: formatDateTime(
					// 		view?.content?.updated_at as unknown as string
					// 	),
					// },
				]}
			/>
			<ExportModal
				onClose={() => setShowExport(false)}
				visible={showExport}
				page="bankbox_requests"
			/>
			<ChangeRequestStatusModal
				visible={showModal.status}
				onClose={() => {
					setShowModal((prev) => {
						return { ...prev, status: false };
					});
				}}
				onFinish={handleFinish}
				details={singleChild}
			/>

			<RavenModal
				onClose={() => {
					setAssignBankbox({ ...assignBankbox, on: false });
					setUploadViaCamera(false);
					setDetails({ state: '', lga: '' });
				}}
				visble={assignBankbox.on}
				// visble={true}
				loading={loading}
				onBtnClick={handleAssign}
				btnColor="deep-green-light"
				btnLabel={!uploadViaCamera ? 'Assign Terminal' : ''}
				className={`session-expired-wrap-modal`}
				disabled={
					autoAssign &&
					(!assignFormData?.label ||
						!assignFormData?.serial_number ||
						!details?.lga ||
						!details?.state)
						? true
						: !autoAssign &&
						  (!assignFormData?.terminal_id ||
								!assignFormData?.label ||
								!details?.lga ||
								!details?.state)
						? true
						: false
				}
			>
				<div
					// onClick={() => {
					// 	//(user);
					// }}
					className="assign-bb-modal"
				>
					<div className="assign-bb-modal__title">
						<h6>Assign Terminal</h6>
						<p>
							{uploadViaCamera
								? `Ensure to capture the BankBox serial number`
								: `Allocate Bankbox to a user`}
						</p>
					</div>
					{/* <MyComponent />  */}
					{/* {!uploadViaCamera && (
						<div
							onClick={() => {
								setUploadViaCamera(true);
							}}
							className="camera-icon-box"
						>
							<div className="camera-icon">
								<figure className="img-box grey-bg">{cameraIcon}</figure>
							</div>
							<p>Use webcam to get bankbox serial no</p>
						</div>
					)} */}
					{uploadViaCamera ? (
						<>
							{/* <WebcamCapture /> */}
							<CameraAssignBox
								onCancel={() => {
									setUploadViaCamera(false);
								}}
								onFinish={(param: any) => {
									setUploadViaCamera(false);
									setTerminalDetails(param);
									setAssignFormData((prev) => {
										return { ...prev, serial_number: param?.actualValue };
									});
								}}
							/>
						</>
					) : (
						<>
							{' '}
							<div className="assign-bb-modal__form-body">
								{/* <RavenInputField
							type="select"
							color="deep-green-light"
							value={assignFormData?.fee_category}
							label="Fee Category"
							style={{ position: 'relative', zIndex: 10 }}
							placeholder="Select Fee Category"
							name="fee_category"
							selectOption={formatFeeCategory()}
							onChange={(e: any) => {
								setAssignFormData((prev) => {
									return { ...prev, fee_category: e };
								});
							}}
						/> */}
								<div className="serial-number-input-form-group">
									<RavenInputField
										type={`account-number`}
										maxLength={10}
										color="deep-green-light"
										value={assignFormData?.serial_number}
										label="BankBox Serial Number"
										onChange={(e: any) => {
											setAssignFormData({
												...assignFormData,
												serial_number: e.target.value,
											});
											if (terminalDetails) {
												setTerminalDetails({});
											}
										}}
										placeholder="Input last 10 digit of your BankBox serial number"
										name="serial"
										// labelSpanText={
										// 	terminalDetails?.fullValue ? (
										// 		((
										// 			<>
										// 				<div
										// 					onClick={() => {
										// 						setUploadViaCamera(true);
										// 					}}
										// 					className="camera-icon-box"
										// 				>
										// 					<div className="camera-icon">
										// 						<figure className="img-box grey-bg">
										// 							{cameraIcon}
										// 						</figure>
										// 					</div>
										// 					<p>Input via webcam</p>
										// 				</div>
										// 			</>
										// 		) as any)
										// 	) : (
										// 		<div
										// 			onClick={() => {
										// 				setUploadViaCamera(true);
										// 			}}
										// 			className="camera-icon-box"
										// 		>
										// 			<div className="camera-icon">
										// 				<figure className="img-box grey-bg">
										// 					{cameraIcon}
										// 				</figure>
										// 			</div>
										// 			<p>Input via webcam </p>
										// 		</div>
										// 	)
										// }
									/>
									<div
										onClick={() => {
											setUploadViaCamera(true);
										}}
										className="upload-toggle-box  white-black-bg border-theme"
									>
										<figure className="img-box tooltip-hover-wrap">
											{cameraUploadIcon}
											<RavenToolTip
												textColor="white-light"
												color={`deep-green-light`}
												position={`bottom-left`}
												text="Enter serial number via webcam "
											/>
										</figure>
									</div>
								</div>

								<RavenInputField
									type="text"
									value={assignFormData?.label}
									onChange={(e: any) => {
										setAssignFormData({
											...assignFormData,
											label: e.target.value,
										});
									}}
									color="deep-green-light"
									label="BankBox Label"
									placeholder="E.g Eatery one"
									name="serial"
								/>
								{/* auto generate box start */}
								{/* two input field box start */}
								<div
									style={{ position: 'relative', zIndex: '10' }}
									className="two-input-field-box"
								>
									<form autoComplete="off" style={{ width: '100%' }} action="">
										<RavenInputField
											menuPlacement={`top`}
											selectStyles={reactSelectStyle}
											color="deep-green-light"
											label="State * "
											type="select"
											placeholder="Select option"
											value={details?.state}
											onChange={(e: any) => {
												setDetails((prev) => {
													return { ...prev, state: e, lga: '' };
												});
												// if
												// dispatch(
												// 	bankboxAPI.getBankboxLgaByStates({ region: e.value })
												// );
											}}
											// disabled={user?.region ? true : false}
											selectOption={formatState(all_states)}
										/>
									</form>
									<form autoComplete="off" style={{ width: '100%' }} action="">
										{' '}
										<RavenInputField
											selectStyles={reactSelectStyle}
											menuPlacement={`top`}
											color="deep-green-light"
											label="City* "
											type="text"
											placeholder="Enter city"
											disabled={!details?.state}
											value={details?.lga}
											onChange={(e: any) => {
												setDetails((prev) => {
													return { ...prev, lga: e?.target?.value };
												});
											}}
											selectOption={formatState(all_lga)}
											// loadingSelect={true}
										/>
									</form>
								</div>
								{/* two input field box end */}
								<div
									style={{ position: 'relative', zIndex: '20' }}
									className="auto-generate-box-wrap"
								>
									<div className="togle-info-box">
										{' '}
										<RavenToggleSlide
											className="toggle-cor"
											value={autoAssign}
											checked={autoAssign}
											onChange={() => {
												setAutoAssign(!autoAssign);
											}}
											color={`deep-green-light`}
										/>
									</div>

									<p className="text">Autogenerate Terminal ID</p>
									<div className="info-box">
										<figure className="img-box tooltip-hover-wrap">
											{infoIcon}
											<RavenToolTip
												textColor="white-light"
												color={`deep-green-light`}
												position={`top-left`}
												text="Select this option if you want us to handle the management of your Terminal ID and other background work included."
											/>
										</figure>
									</div>
								</div>
								{/* auto generate box end */}
								{/* auto assin content start */}
								{!autoAssign && (
									<div className="auto-assign-content-box">
										<RavenInputField
											type="text"
											value={assignFormData?.terminal_id}
											showError={showTerminalError}
											onChange={(e: any) => {
												if (e.target.value?.length < 9) {
													setShowTerminalError(false);
													setAssignFormData((prev) => {
														return { ...prev, terminal_id: e.target.value };
													});
												}
											}}
											color="deep-green-light"
											label="Terminal ID"
											placeholder="Enter Terminal ID"
											name="term_id"
											// maxSize={8}
										/>
										{/* select option start  */}
										<div
											className="select-option-box-wrap"
											style={{ marginTop: '2.4rem' }}
										>
											<label htmlFor="">
												Is this Terminal ID registered on NIBSS?
											</label>
											<div className={'export-modal__export-as--selector-wrap'}>
												{selectTypeList?.map((chi, idx) => {
													return (
														<div
															key={idx}
															onClick={() => {
																setSelectedType(chi);
																setAssignFormData((prev) => {
																	return {
																		...prev,
																		exist_nibbs:
																			chi === 'Yes, It is' ? true : false,
																	};
																});
															}}
															className={`selector-wrap__item ${
																selectedType === chi && 'selected'
															}`}
														>
															<figure>
																{selectedType === chi
																	? icons.radio_check
																	: icons.radio_unchecked}
															</figure>
															<p>{chi}</p>
														</div>
													);
												})}
											</div>
										</div>
										{/* select option end */}
									</div>
								)}
								{/* auto assin content end */}
							</div>
						</>
					)}
				</div>
			</RavenModal>
		</>
	);
};

export default BankboxRequest;
